const SITE_KEY = process.env.REACT_APP_GCAPTCHA_SITE_KEY;

let scriptLoadingPromise = null;

export function loadRecaptcha() {
  if (!SITE_KEY) {
    return Promise.reject(new Error("reCAPTCHA site key is not configured"));
  }

  if (window.grecaptcha?.execute) {
    return Promise.resolve();
  }

  if (scriptLoadingPromise) {
    return scriptLoadingPromise;
  }

  scriptLoadingPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
    script.async = true;
    script.onload = () => {
      window.grecaptcha.ready(resolve);
    };
    script.onerror = () => {
      scriptLoadingPromise = null;
      reject(new Error("Failed to load reCAPTCHA"));
    };
    document.head.appendChild(script);
  });

  return scriptLoadingPromise;
}

export async function executeRecaptcha(action) {
  await loadRecaptcha();
  return window.grecaptcha.execute(SITE_KEY, { action });
}
